import {
  FETCH_DISTRIBUTORPROFILE_SUCCESS_ACTION,
  FETCH_DISTRIBUTORPROF_SUCCESS_ACTION,
  FETCH_STATES_SUCCESS_ACTION,
  FETCH_DISTRICTBYID_SUCCESS_ACTION,
  FETCH_BANK_SUCCESS_ACTION
} from "./action";

const initialState = {
  processing: false,
  error: false
};

export default function(state: any = initialState, action: Function) {
  switch (action.type) {
    case FETCH_DISTRIBUTORPROFILE_SUCCESS_ACTION:
      // console.log("!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!", action.payload);
      return {
        ...state,
        DistributorprofDtls: action.payload
      };
    case FETCH_DISTRIBUTORPROF_SUCCESS_ACTION:
      // console.log("distributorprofDtls!!!!!!!!!!!!!!!!", action.payload);
      return {
        ...state,
        distributorprofDtls: action.payload
      };
    case FETCH_STATES_SUCCESS_ACTION:
      // console.log("statesList!!!!!!!!!!!!!!!!", action.payload.rows);
      return {
        ...state,
        statesList: action.payload
      };
    case FETCH_DISTRICTBYID_SUCCESS_ACTION:
      // console.log("districtById!!!!!!!!!!!!!!!!", action.payload.rows);
      return {
        ...state,
        districtById: action.payload.rows
      };
    case FETCH_BANK_SUCCESS_ACTION:
      // console.log("statesList!!!!!!!!!!!!!!!!", action.payload);
      return {
        ...state,
        banks: action.payload
      };

    default:
      return {
        ...state
      };
  }
}
